import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChartsData } from 'types/api/api-charts.types';

export type ChartsSliceType = {
  id: string;
  bitcoinEarnings: [string, number][];
  electricityConsumption: [string, number][];
};

export const initialState: ChartsSliceType = {
  id: '',
  bitcoinEarnings: [],
  electricityConsumption: [],
};

const slice = createSlice({
  name: 'charts',
  initialState,
  reducers: {
    setChartsData: (state, action: PayloadAction<ChartsData>) => {
      state.id = action.payload.id;
      state.bitcoinEarnings = action.payload.bitcoinEarnings;
      state.electricityConsumption = action.payload.electricityConsumption;
    },
  },
});

export default slice.reducer;

// selectors
export const chartsSelector = (state: { charts: ChartsSliceType }) => state.charts;
export const bitcoinEarningsSelector = (state: { charts: ChartsSliceType }) => state.charts.bitcoinEarnings;
export const electricityConsumptionSelector = (state: { charts: ChartsSliceType }) =>
  state.charts.electricityConsumption;

export const { setChartsData } = slice.actions;

// actions
